import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { changeModal, getOneNotification, closeNotification, getNotifications } from "../../../actions/notificationActions"

const NotificationModal = () => {
    const showNotification = useSelector(state => state.notificationData.showNotification),
        data = useSelector(state => state.notificationData.notificationList),
        limit = useSelector(state => state.notificationData.limit),
        totalDataCount = useSelector(state => state.notificationData.total),
        page = useSelector(state => state.notificationData.pageDesign),
        dispatch = useDispatch();

    const toggleModal = () => {
        dispatch(changeModal())
    }
    const toNotifications = () => {
        let userId = sessionStorage.getItem("userId");
        dispatch(getNotifications(userId, limit + 10))
    }
    const getNotification = (id) => {
        dispatch(changeModal())
        dispatch(closeNotification())
        dispatch(getOneNotification(id))
    }
    return (
            <>
                <Modal isOpen={showNotification} toggle={(e) => toggleModal()} className={page === "home" ? "notification-modal home-page-modal" : "notification-modal"}>
                    <div className="notification-header">New Updates</div>
                    <ModalBody className="notification-body">
                        {data && data.length > 0 ? (
                            <ul className="notification-list">
                                {data.map((item) => (
                                    <li className={item.status === 0 ? "notification-item unread-notification" : "notification-item"} key={item._id} onClick={() => getNotification(item._id)}>
                                        <div className="notification-category"><p>{item.category}</p></div>
                                        
                                        <div className='notification-details'>
                                            <div className='notification-content-wrapper'>
                                                <div className="notification-title"> {item.title}</div>
                                                <div className="notification-description">{item.content}</div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="no-notification">No notifications available</div>
                        )}
                    </ModalBody>

                    {totalDataCount && data && data.length && totalDataCount !== data.length ?
                        <ModalFooter className="notification-footer">
                            <Button className="load-more-button" onClick={(e) => toNotifications()}>See More....</Button>
                        </ModalFooter> : null}
                </Modal>
            </>
    )
}

export default NotificationModal;